var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphonesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.25 10a7.75 7.75 0 1115.5 0v5a2.75 2.75 0 11-5.5 0v-3a2.75 2.75 0 013.983-2.459 6.25 6.25 0 00-12.466 0A2.75 2.75 0 017.75 12v3a2.75 2.75 0 11-5.5 0v-5zm1.5 2v3a1.25 1.25 0 102.5 0v-3a1.25 1.25 0 10-2.5 0zm12.5 0a1.25 1.25 0 10-2.5 0v3a1.25 1.25 0 102.5 0v-3z"
  })));
}
export default SvgHeadphonesIcon;